import ApexCharts, {ApexOptions} from 'apexcharts'
import axios, {AxiosResponse} from 'axios'
import currency from 'currency.js'
import React, {useEffect, useRef, useState} from 'react'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import store from '../../../../setup/redux/Store'
import {getCSS, getCSSVariableValue} from '../../../assets/ts/_utils'
import Chart from 'react-apexcharts'
import {IDR} from '../../../helpers'
import {APIResponse} from '../../../../app/models/HelperModel'

type Props = {
  className: string
}

type ResponseType<T> = {
  success?: boolean
  message?: string
  data: T[]
}

interface Penarikan {
  thang: currency
  jan: currency
  feb: currency
  mar: currency
  apr: currency
  mei: currency
  jun: currency
  jul: currency
  ags: currency
  sep: currency
  okt: currency
  nov: currency
  des: currency
}

const API_URL = process.env.REACT_APP_API_URL
const REQUEST_TARGET_PENYERAPAN = `${API_URL}/penarikan`
const REQUEST_REALISASI_PENYERAPAN = `${API_URL}/anggaran/total`

const ChartBeranda: React.FC<Props> = ({className}) => {
  // const chartRef = useRef<HTMLDivElement | null>(null)
  const [fiscalYear, setFiscalYear] = useState<number>(
    useSelector<RootState>(({fiscalYear}) => fiscalYear.fiscalYear) as number
  )
  const [seriesChart, setSeriesChart] = useState<
    ApexAxisChartSeries | ApexNonAxisChartSeries | undefined
  >([
    {
      name: 'Target Penyerapan Anggaran',
      type: 'area',
      //data: [2, 5, 10, 39, 43, 49, 53, 60, 65, 79, 87, 100],
      data: [],
    },
    {
      name: 'Realisasi Penyerapan Anggaran',
      type: 'bar',
      data: [],
    },
  ])
  const [chartOptions, setChartOptions] = useState(getChartOptions())
  const [paguAnggaran, setPaguAnggaran] = useState<currency>(currency(0))

  store.subscribe(handleChangeFiscalYear)

  function handleChangeFiscalYear() {
    const {
      fiscalYear: {fiscalYear},
    } = store.getState()

    setFiscalYear(fiscalYear as number)
  }

  const reqTargetPenyerapan = axios.get<ResponseType<Penarikan>>(REQUEST_TARGET_PENYERAPAN, {
    params: {th: fiscalYear},
  })
  const reqRealisasiPenyerapan = axios.get<APIResponse<Penarikan>>(REQUEST_REALISASI_PENYERAPAN, {
    params: {th: fiscalYear},
  })

  useEffect(() => {
    let targetPenyerapan: Penarikan
    let realisasiPenyerapan: Penarikan

    Promise.all([reqTargetPenyerapan, reqRealisasiPenyerapan])
      .then((results) => {
        let seriesDataTarget: number[]
        let seriesDataRealisasi: number[]

        let responseTargetPenyerapan = results[0]
        let responseRealisasiPenyerapan = results[1]
        let jumlahPagu : currency = new currency(0)

        // Data series untuk Target Anggaran
        if (responseTargetPenyerapan.data.data.length === 0) {
          seriesDataTarget = []

          setChartOptions({
            ...chartOptions,
            title: {
              text: 'Pagu Anggaran Rp. 0,-',
              align: 'center',
              style: {
                fontWeight: 600,
              },
            },
          })

          // setPaguAnggaran(currency(0))
          jumlahPagu = currency(0)
        } else {
          targetPenyerapan = responseTargetPenyerapan.data.data[0]

          seriesDataTarget = [
            currency(targetPenyerapan.jan).divide(targetPenyerapan.des).intValue,
            currency(targetPenyerapan.feb).divide(targetPenyerapan.des).intValue,
            currency(targetPenyerapan.mar).divide(targetPenyerapan.des).intValue,
            currency(targetPenyerapan.apr).divide(targetPenyerapan.des).intValue,
            currency(targetPenyerapan.mei).divide(targetPenyerapan.des).intValue,
            currency(targetPenyerapan.jun).divide(targetPenyerapan.des).intValue,
            currency(targetPenyerapan.jul).divide(targetPenyerapan.des).intValue,
            currency(targetPenyerapan.ags).divide(targetPenyerapan.des).intValue,
            currency(targetPenyerapan.sep).divide(targetPenyerapan.des).intValue,
            currency(targetPenyerapan.okt).divide(targetPenyerapan.des).intValue,
            currency(targetPenyerapan.nov).divide(targetPenyerapan.des).intValue,
            currency(targetPenyerapan.des).divide(targetPenyerapan.des).intValue,
          ]

          setChartOptions({
            ...chartOptions,
            title: {
              text: `Pagu Anggaran ${IDR(targetPenyerapan.des).format()}`,
              align: 'center',
              style: {
                fontWeight: 600,
              },
            },
          })

          // setPaguAnggaran(targetPenyerapan.des)
          jumlahPagu = targetPenyerapan.des
        }

        //Data series untuk Penyerapan Anggaran
        if (responseRealisasiPenyerapan.data.data !== null) {
          if (responseRealisasiPenyerapan.data.data !== undefined) {
            realisasiPenyerapan = responseRealisasiPenyerapan.data.data

            console.log()

            seriesDataRealisasi = [
              currency(realisasiPenyerapan.jan).divide(jumlahPagu).intValue,
              currency(realisasiPenyerapan.feb).divide(jumlahPagu).intValue,
              currency(realisasiPenyerapan.mar).divide(jumlahPagu).intValue,
              currency(realisasiPenyerapan.apr).divide(jumlahPagu).intValue,
              currency(realisasiPenyerapan.mei).divide(jumlahPagu).intValue,
              currency(realisasiPenyerapan.jun).divide(jumlahPagu).intValue,
              currency(realisasiPenyerapan.jul).divide(jumlahPagu).intValue,
              currency(realisasiPenyerapan.ags).divide(jumlahPagu).intValue,
              currency(realisasiPenyerapan.sep).divide(jumlahPagu).intValue,
              currency(realisasiPenyerapan.okt).divide(jumlahPagu).intValue,
              currency(realisasiPenyerapan.nov).divide(jumlahPagu).intValue,
              currency(realisasiPenyerapan.des).divide(jumlahPagu).intValue,
            ]
          } else {
            seriesDataRealisasi = []
          }
        } else {
          seriesDataRealisasi = []
        }

        setSeriesChart([
          {
            name: 'Target Penyerapan Anggaran',
            type: 'area',
            // data: [2, 5, 10, 39, 43, 49, 53, 60, 65, 79, 87, 100],
            data: seriesDataTarget,
          },
          {
            name: 'Realisasi Penyerapan Anggaran',
            type: 'bar',
            data: seriesDataRealisasi,
          },
        ])
      })
      .catch((err) => {
        console.log(err)
      })
  }, [fiscalYear])

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3 mb-1'>
            Target dan Realisasi Penyerapan Anggaran
          </span>
        </h3>
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card-body'>
        {/* begin::Chart */}
        {/* <div
          ref={chartRef}
          id='kt_charts_target_realisasi_anggaran'
          style={{height: '350px'}}
        ></div> */}
        <Chart
          series={seriesChart}
          options={chartOptions}
          height={'350px'}
          key={'chart_beranda_001'}
        />

        {/* end::Chart */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export default ChartBeranda

function getChartOptions(): ApexOptions {
  const labelColor = getCSSVariableValue('--bs-gray-500')
  const borderColor = getCSSVariableValue('--bs-gray-200')

  const color1 = getCSSVariableValue('--bs-warning')
  const color1Light = getCSSVariableValue('--bs-light-warning')

  const color2 = getCSSVariableValue('--bs-success')
  const color2Light = getCSSVariableValue('--bs-light-success')

  return {
    series: [
      {
        name: 'Target Penyerapan Anggaran',
        type: 'area',
        //data: [2, 5, 10, 39, 43, 49, 53, 60, 65, 79, 87, 100],
        data: [],
      },
      {
        name: 'Realisasi Penyerapan Anggaran',
        type: 'bar',
        data: [],
      },
    ],
    // title: {
    //   text: '',
    //   align: 'center',
    //   style: {
    //     fontWeight: 600,
    //   },
    // },
    chart: {
      fontFamily: 'inherit',
      type: 'area',
      height: 350,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {},
    legend: {
      show: true,
      markers: {
        fillColors: [color1, color2],
      },
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: 'solid',
      colors: [color1Light, color2],
    },
    stroke: {
      curve: 'straight',
      show: true,
      width: 3,
      colors: [color1, color2],
    },
    xaxis: {
      categories: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Des',
      ],
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
      crosshairs: {
        position: 'front',
        stroke: {
          color: color1,
          width: 1,
          dashArray: 3,
        },
      },
      tooltip: {
        enabled: true,
        formatter: undefined,
        offsetY: 0,
        style: {
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
      seriesName: 'Target Penyerapan Anggaran',
      min: 0,
      max: 100,
      tickAmount: 5,
      decimalsInFloat: 2,
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
    tooltip: {
      style: {
        fontSize: '12px',
      },
      y: {
        formatter: function (val) {
          return val + ' persen'
        },
      },
    },
    colors: [color1, color2],
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    markers: {
      strokeColors: [color1, color2],
      strokeWidth: 3,
      size: 3,
    },
    noData: {
      text: 'Loading...',
    },
  }
}
